/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Tags from "./Tags";

class TopicsPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			values: [],
		};
	}

	componentDidMount() {
		this.getExperiences();
	}

	getExperiences = () => {
		let values = [];
		const { experiences } = this.props;
		if (experiences && experiences.length) {
			experiences.forEach(exp => {
				values.push({
					id: exp.id,
					label: `${exp.name} Experience`,
				});
			});
		}
		this.setState({ values });
	};

	render() {
		const { max } = this.props;
		return (
			<div className="picker-input">
				{this.state.values && (
					<Tags
						{...this.props}
						max={max ? max : null}
						dataObjects={this.state.values}
						dataObjectKey="id"
						dataObjectLabel="label"
						minQueryLength={1}
						allowNew
						handleAddition={this.handleAddition}
					/>
				)}
			</div>
		);
	}
}

TopicsPicker.propTypes = {
	fieldState: PropTypes.object,
	fieldApi: PropTypes.object,
	dataObjects: PropTypes.array,
	dataObjectKey: PropTypes.string,
	dataObjectLabel: PropTypes.string,
	allowNew: PropTypes.bool,
	placeholder: PropTypes.string,
	tagInstructions: PropTypes.string,
	experiences: PropTypes.array,
	max: PropTypes.number,
	isRequired: PropTypes.bool,
};

const mapStateToProps = state => ({
	apps: state.apps.apps,
	experiences: state.experiences.experiences,
});

export default connect(mapStateToProps)(TopicsPicker);
